<div class="prompt-container">
    <h1 mat-dialog-title>{{data.title}}</h1>
    <p>{{data.text}}</p>
    <div mat-dialog-actions>
        <button mat-stroked-button color="warn" [mat-dialog-close]="true">{{ 'Ok' | translate }}</button>
        <button mat-stroked-button class="light" (click)="onNoClick()">{{ 'No Thanks' | translate }}</button>
    </div>
</div>
